import React, { useEffect } from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';

// Pages
import LandingPage from './pages/LandingPage';
import SignupPage from './pages/SignupPage';
import SigninPage from './pages/SigninPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import CreateAvatarPage from './pages/CreateAvatarPage';
import AvatarChatPage from './pages/AvatarChatPage';
import AvatarDetailsPage from './pages/AvatarDetailsPage';
import ProjectChatPage from './pages/ProjectChatPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import AddonPaymentSuccessPage from './pages/AddonPaymentSuccessPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import ContactPage from './pages/ContactPage';

function App() {
  const location = useLocation();
  const navigate = useNavigate();

  // Redirect invite links to signup EXCEPT when the link intentionally targets /signin.
  // - New users should land on /signup
  // - Existing users can land on /signin (email invite logic decides which one to send)
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const inviteId = params.get('invite_id');
    const inviteEmail = params.get('invite_email');
    const isSignup = location.pathname === '/signup';
    const isSignin = location.pathname === '/signin';
    const isCreateAvatar = location.pathname === '/create-avatar';
    if ((inviteId || inviteEmail) && !isSignup && !isSignin && !isCreateAvatar) {
      const newParams = new URLSearchParams();
      if (inviteId) newParams.set('invite_id', inviteId);
      if (inviteEmail) newParams.set('invite_email', inviteEmail);
      navigate(`/signup?${newParams.toString()}`, { replace: true });
    }
  }, [location.search, location.pathname, navigate]);

  return (
    <div className="app">
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/signin" element={<SigninPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/create-avatar" element={<CreateAvatarPage />} />
        <Route path="/chat" element={<AvatarChatPage />} />
        <Route path="/payment/success" element={<PaymentSuccessPage />} />
        <Route path="/payment/addon/success" element={<AddonPaymentSuccessPage />} />
        <Route path="/avatar/:id" element={<AvatarDetailsPage />} />
        <Route path="/projects" element={<ProjectChatPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/contact" element={<ContactPage />} />
        {/* Catch-all route - redirect to home if route not found */}
        <Route path="*" element={<LandingPage />} />
      </Routes>
    </div>
  );
}

export default App;
